import React, { useState } from "react";

import Header from "../../../components/Header/Header";
import Footer from "../../../components/Footer/Footer";
import StickyFooter from "../../../components/Footer/StickyFooter";
import NewsLetter from "../../../components/Home/NewsLetter/NewsLetter";
import Breadcrumb from "../../../components/Home/Breadcrumb/Breadcrumb";
import Results from "../../../templates/search-results-template";
import PropertyFooterNew from "../../../components/Footer/propertyFooterNew.js";
import ResultsFaq from "../../../components/ResultsFaq/ResultsFaq.js";
import {
  parseSearchUrl
} from "../../../components/SearchResult/utills";
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/scss/bootstrap.scss';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "../../../scss/bootstrap-overrides.scss";
import "../../../scss/grunticon.scss";
import "../../../scss/global.scss";
import "../../../scss/custom.scss";

const ResidentialSales = (props) => {
  const [showMenu, setShowMenu] = useState(false);

  const handlerClick = () => {
    setShowMenu(prev => !prev);
  };

  const fullpath = props.location.pathname;
  const location = props.location;
  const fullpathone = props.location;

  const searchParams = parseSearchUrl("sales", fullpath);

  return (
    <div
      className={`${
        showMenu ? "open-search-block" : ""
      } search-results-listings-wrap`}
    >
      <Header
        showMenu={showMenu}
        handlerClick={handlerClick}
        fixed={true}
      />

      <Breadcrumb
        data=""
        name="Properties for sale in Dubai"
        link="/properties/for-sale/in-dubai/"
        tag="detail-page"
        params={searchParams}
        fullpathname={fullpath}
      />

      <Results
        location={location}
        locationname="/properties/for-sale/"
        pcategorytype="residential"
        fullpathone={fullpathone}
        fullpathname={fullpath}
        ptype="sales"
        ptypetag="for-sale"
      />

      <PropertyFooterNew
        Action="for-sale"
        Area={searchParams.areas}
        Property_Type={searchParams.type}
      />

      <ResultsFaq />

      <Footer popularSearch="Popular_Search_Sale" />
    </div>
  );
};

export default ResidentialSales;
